import React from 'react';
import CoinsTable from '../Components/trading/CoinsTable';


const Trading = () => {
      return (

            <CoinsTable/>
      );
};

export default Trading;
